<template>
  <div v-if="status.review" class="row">
    <div class="col-sm-12 text-center mb-3">
      <p v-if="status.review === 'pending'" role="status">
        <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
        {{ $t("requestErrors.reviewPending") }}
      </p>
      <div v-if="status.review === 'success'" class="alert alert-success" role="status">
        <h2 class="h4">{{ $t("common.reviewThanks") }}</h2>
        {{ $t("common.reviewSuccess") }}
      </div>
      <RequestError v-if="status.review === 'failed'" :error="errors.review" keep-inputs />
    </div>
    <div v-if="status.newsletter" class="col-sm-12 text-center mb-3">
      <p v-if="status.newsletter === 'pending'" role="status">
        <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
        {{ $t("requestErrors.newsletterPending") }}
      </p>
      <p v-if="status.newsletter === 'success'" class="alert alert-success" role="status">
        {{ $t("common.addedToNewsletter") }}
      </p>
      <RequestError v-if="status.newsletter === 'failed'" :error="errors.newsletter" keep-inputs />
    </div>
    <div v-if="status.review !== 'pending'" class="col-sm-12 text-center mb-5">
      <button type="button" class="btn btn-outline-secondary me-3 mb-2" :disabled="submitting" @click="$emit('backToForm')">
        {{ $t("common.backToForm") }}
      </button>
      <button type="button" class="btn btn-outline-secondary mb-2" :disabled="submitting" @click="$emit('backToOverview')">
        {{ $t("common.backToOverview") }}
      </button>
    </div>
  </div>
</template>

<script>
import RequestError from "./RequestError.vue";

export default {
  components: { RequestError },
  props: {
    status: { type: Object, required: true },
    errors: { type: Object, required: true },
    submitting: Boolean,
  },
};
</script>
